<section class="app-section form-card">
  @if (error()) {
    <p role="alert">{{ 'workforceCutover.failed' | translate }}</p>
  }
  <form class="form-grid" (ngSubmit)="save()">
    <label class="form-field"
      >{{ 'workforceCutover.kind' | translate }}
      <select class="picker-button"
        name="mode"
        [(ngModel)]="mode"
        [disabled]="!!shift() || !!absence()"
      >
        <option value="shift">
          {{ 'nav-item.workforce.shifts' | translate }}
        </option>
        <option value="absence">
          {{ 'workforceCutover.absence' | translate }}
        </option>
        <option value="compensation">
          {{ 'workforceCutover.compensation' | translate }}
        </option>
      </select>
    </label>
    <label class="form-field"
      >{{ 'shift.person' | translate
      }}<select class="picker-button"
        name="worker"
        [(ngModel)]="worker"
        required
        [disabled]="!!shift() || !!absence()"
      >
        @for (w of options().workers; track w.id) {
          <option [value]="w.id">{{ w.name }}</option>
        }
      </select></label
    >
    @if (mode !== 'absence') {
      <label class="form-field"
        >{{ 'workforceCutover.site' | translate
        }}<select class="picker-button"
          name="site"
          [(ngModel)]="site" (ngModelChange)="loadProjects()"
          required
          [disabled]="!!shift() || !!absence()"
        >
          @for (s of options().sites; track s.id) {
            <option [value]="s.id">{{ s.name }}</option>
          }
        </select></label
      >
    }
    <label class="form-field"
      >{{ 'workforceCutover.start' | translate
      }}<input class="picker-button"
        name="start"
        type="date"
        [(ngModel)]="start"
        required
        [disabled]="!!shift() || !!absence()"
    /></label>
    @if (mode !== 'compensation' && !shift()) {
      <label class="form-field"
        >{{ 'workforceCutover.end' | translate
        }}<input class="picker-button" name="end" type="date" [(ngModel)]="end" required
      /></label>
    }
    @if (mode === 'shift') {
      <label class="form-field"
        >{{ 'workforceCutover.from' | translate
        }}<input class="picker-button" name="from" type="time" [(ngModel)]="from" required
      /></label>
      <label class="form-field"
        >{{ 'workforceCutover.until' | translate
        }}<input class="picker-button" name="until" type="time" [(ngModel)]="until" required
      /></label>
      <label class="form-field"
        >{{ 'workforceCutover.break' | translate
        }}<input class="picker-button"
          name="unpaid"
          type="number"
          [(ngModel)]="unpaid"
          min="0"
          max="1439"
          required
      /></label>
      @if (!shift()) {
        <label class="form-field"
          ><input name="weekdays" type="checkbox" [(ngModel)]="weekdays" />{{
            'workforceCutover.weekdays' | translate
          }}</label
        >
      }
    }
    @if (mode === 'absence') {
      <label class="form-field"
        >{{ 'workforceCutover.kind' | translate
        }}<select class="picker-button" name="type" [(ngModel)]="type">
          @for (t of ['HOLIDAY', 'SICKNESS', 'OTHER']; track t) {
            <option [value]="t">
              {{ 'workforceCutover.' + t | translate }}
            </option>
          }
        </select></label
      >
    }
    @if (mode === 'compensation') {
      <label class="form-field"
        >{{ 'workforceCutover.kind' | translate
        }}<select class="picker-button" name="compensationType" [(ngModel)]="compensationType">
          @for (
            t of [
              'KILOMETRES',
              'FULL_PER_DIEM',
              'PARTIAL_PER_DIEM',
              'MEAL',
              'OTHER',
            ];
            track t
          ) {
            <option [value]="t">
              {{ 'workforceCutover.' + t | translate }}
            </option>
          }
        </select></label
      >
      <label class="form-field"
        >{{ 'workforceCutover.quantity' | translate
        }}<input class="picker-button"
          name="quantity"
          type="number"
          min="0.01"
          step="0.01"
          [(ngModel)]="quantity"
          required
      /></label>
    }
    <label class="form-field"
      >{{ 'workforceCutover.note' | translate
      }}<textarea class="picker-button" name="note" [(ngModel)]="note" maxlength="4000"></textarea>
    </label>
    @if(mode!=='absence'){
      <label class="form-field">{{'workforceV2.project'|translate}}<select class="picker-button" name="project" [(ngModel)]="project"><option value="">—</option>@for(p of projects();track p.id){<option [value]="p.id">{{p.name}}</option>}</select></label>
    }
    <button class="pill-button" type="submit" [disabled]="busy()">
      {{ 'workforceCutover.save' | translate }}
    </button>
    @if (absence()) {
      <button class="pill-button" type="button" [disabled]="busy()" (click)="save(true)">
        {{ 'workforceCutover.cancelAbsence' | translate }}
      </button>
    }
    @if (shift()) {
      <button class="pill-button" type="button" [disabled]="busy()" (click)="save(true)">
        {{ 'workforceCutover.cancelShift' | translate }}
      </button>
    }
  </form>
</section>
